import React from 'react';
import { Typography } from '@mui/material';
import { fontSizes } from '../../layouts/fontSizes';
import pallet from '../../layouts/pallet';

interface PlaceholderProps {
  text: string;
}

const Placeholder = ({ text }: PlaceholderProps) => (
  <Typography
    fontSize={`${fontSizes.placeHolder} !important`}
    color={pallet.greyText}
  >
    {text}
  </Typography>
);

export default Placeholder;
